<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :confirm-loading="confirmLoading"
      size="1300_auto"
      no-padding>
    <template #header>
      <div v-html="title"></div>
    </template>
    <template #content>
<!--      <p>{{form.placementBidForm | json}}</p>-->
      <div v-loading="loading"
           style="padding: 16px 20px 0 20px;">
        <gj-area-title :isChunk="false">基础信息</gj-area-title>
        <el-form
            ref="form"
            :model="form"
            :inline="true"
            label-width="120px"
            style="margin-bottom: 4px;">

<!--          模板名称-->
          <el-form-item
              v-if="opType === OpEnum.type.ADD || opType === OpEnum.type.UPDATE"
              label="模板名称"
              prop="name"
              label-width="100px"
              :rules="[ { required: true, message: '请输入模板名称', trigger: ['blur', 'change'] } ]">
            <gj-input
                v-model="form.name"
                width="250px"
            ></gj-input>
          </el-form-item>

<!--          选择模板、策略状态-->
          <template v-if="opType === OpEnum.type.USE">
            <el-form-item
                label="选择模板"
                prop="proxyTemplateId"
                label-width="100px"
                :rules="[ { required: true, message: '请选择模板', trigger: ['blur', 'change'] } ]">
              <gj-select
                  v-model="form.proxyTemplateId"
                  :options="option.template"
                  :loading="option.templateLoading"
                  :clearable="false"
                  width="250px"
                  @input-option="proxyTemplateInput"
              ></gj-select>
            </el-form-item>
            <el-form-item
                prop="tplPlanState"
                label-width="128px">
              <template #label>
                策略状态
                <gj-help>操作状态后，需要确认修改后才会更新状态，开启策略后，策略将在下一个生效时段开始生效，关闭策略后，策略会立即失效</gj-help>
              </template>
              <gj-switch
                  v-if="$permission('adsStrategyObject:delete')"
                  v-model="form.tplPlanState"
              ></gj-switch>
              <template v-else>{{form.tplPlanState ? '启用' : '暂停'}}</template>
            </el-form-item>
          </template>

<!--          起止时间-->
          <el-form-item label-width="100px">
            <template #label>
              起止时间
              <gj-help>设置后分时调整仅在设定时间范围内生效，超过时间范围自动恢复原价</gj-help>
            </template>
            <gj-date-picker
                v-model="form.date"
                type="daterange"
                :disabled="opType === OpEnum.type.USE && form.proxyTemplateId !== temporaryTemplateId"
                width="250px"
            ></gj-date-picker>
          </el-form-item>

<!--          是否共享-->
          <el-form-item
              label-width="92px"
              v-if="opType === OpEnum.type.ADD || opType === OpEnum.type.UPDATE"
              label="是否共享">
            <el-radio-group v-model="form.share">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>

<!--          结果通知-->
          <div>
            <el-form-item
                prop="notifyType"
                label-width="100px"
                :rules="[ form.notifyType !== 2?{ required: true,validator: validatorName, trigger: ['change'] }:{required: true} ]"
            >
              <template #label>
                结果通知
                <gj-help>
                  分时策略执行完成后，会通过站内消息、微信公众号通知您执行的结果。<br>
                  <div class="flex" style="align-items: baseline">
                    <span class="tooltip-dot"></span>不通知：每次执行完成后都不会通知到您；
                  </div>
                  <div class="flex" style="align-items: baseline">
                    <span class="tooltip-dot"></span>执行完成通知：每次执行完都将通知您；
                  </div>
                  <div class="flex" style="align-items: baseline">
                    <span class="tooltip-dot"></span>有错误时通知：当有分时策略执行失败的情况下才通知您。
                  </div>
                </gj-help>
              </template>
              <gj-select
                  v-model="form.notifyType"
                  :options="option.resultOption"
                  :clearable="false"
                  :filterable="false"
                  width="120px"
              ></gj-select>

            </el-form-item>
            <gj-creator-select
                v-if="form.notifyType !== 0"
                v-model="form.notifyUserList"
                placeholder="请选择通知人"
                :type="'multi-check'"
                width="160px"
            >
            </gj-creator-select>
          </div>


        </el-form>
        <gj-area-title :isChunk="false">
          <div>
            <span style="margin-right: 20px;">分时策略</span>
            <gj-radio-group size="mini" v-model="strategy" :options="strategyGroup"></gj-radio-group>
          </div>
        </gj-area-title>
        <div style="position: relative;">
          <div v-if="false" class="log-btn">
            <gj-button type="text" @click="viewLog">调整日志</gj-button>
          </div>
<!--          调整竞价-->
          <app-adjust-bid-strategy-form
                v-show="strategy === 1"
                ref="bidStrategyForm"
                :form="form.bidForm"
                :disabled="opType === OpEnum.type.USE && form.proxyTemplateId !== temporaryTemplateId"
                :init-form$="initForm$">
          </app-adjust-bid-strategy-form>
<!--          调整广告位竞价-->
          <app-adjust-placement-bid-strategy-form
              v-show="strategy === 2"
              ref="placementBidForm"
              :form="form.placementBidForm"
              :disabled="opType === OpEnum.type.USE && form.proxyTemplateId !== temporaryTemplateId"
              :init-form$="initForm$">
          </app-adjust-placement-bid-strategy-form>
<!--          调整每日预算-->
          <app-adjust-budget-strategy-form
              v-show="strategy === 3"
              ref="budgetStrategyForm"
              :form="form.budgetForm"
              :disabled="opType === OpEnum.type.USE && form.proxyTemplateId !== temporaryTemplateId"
              :init-form$="initForm$">
          </app-adjust-budget-strategy-form>

          <!-- <el-tabs value="bidForm" type="card">
            <el-tab-pane label="调整竞价" name="bidForm">
              <app-adjust-bid-strategy-form
                  ref="bidStrategyForm"
                  :form="form.bidForm"
                  :disabled="opType === OpEnum.type.USE && form.proxyTemplateId !== temporaryTemplateId"
                  :init-form$="initForm$">
              </app-adjust-bid-strategy-form>
            </el-tab-pane>
            <el-tab-pane label="调整广告位竞价" name="placementBidForm">
              <app-adjust-placement-bid-strategy-form
                  ref="placementBidForm"
                  :form="form.placementBidForm"
                  :disabled="opType === OpEnum.type.USE && form.proxyTemplateId !== temporaryTemplateId"
                  :init-form$="initForm$">
              </app-adjust-placement-bid-strategy-form>
            </el-tab-pane>
            <el-tab-pane label="调整每日预算" name="budgetForm">
              <app-adjust-budget-strategy-form
                  ref="budgetStrategyForm"
                  :form="form.budgetForm"
                  :disabled="opType === OpEnum.type.USE && form.proxyTemplateId !== temporaryTemplateId"
                  :init-form$="initForm$">
              </app-adjust-budget-strategy-form>
            </el-tab-pane>
          </el-tabs> -->

        </div>
      </div>
    </template>
    <template #footer>
      <gj-button
          @click="cancel">
        取消
      </gj-button>
      <gj-button
          v-if="opType === OpEnum.type.USE && form.proxyTemplateId === temporaryTemplateId"
          @click="saveTpl">
        应用并存为模板
      </gj-button>
      <gj-button
          @click="preview">
        预览
      </gj-button>
      <gj-button
          :loading="confirmLoading"
          type="primary"
          @click="confirm">
        确定
      </gj-button>
    </template>
  </gj-modal>
</template>

<script>
  import {formRuleMixin, modalMixIn, responseMixin} from "@/minxins";
  import {
    addAdsAdjustStrategyTpl,
    getAdsAdjustStrategyTplById,
    getAdsAdjustStrategyTplList,
    updateAdsAdjustStrategyTpl,
    getAdsStrategyObjectInfoById,
    getTemplateResumeCondition,
    getStrategyResumeCondition, getResumeCondition
  } from "@/api/ad";
  import {AdStrategyEnum} from "../../../common/enum";
  import AppAdjustBidStrategyForm from "./components/adjust-bid-strategy-form";
  import AppAdjustBudgetStrategyForm from "./components/adjust-budget-strategy-form";
  import AppAdjustPlacementBidStrategyForm from "./components/adjust-placement-bid-strategy-form";
  import {isMeaningful} from "@/utils/common";
  import {convertToDate, convertToFullDate} from "@/utils/date.util";
  import {OpEnum} from "@/utils/options";
  import AppStrategyTplLogModal from "../log/strategy-tpl-log-modal";
  import AppSaveStrategyTplModal from "./modal/save-strategy-tpl-modal";
  import AppTimeAdjustStrategyOpErrorModal from "./modal/time-adjust-strategy-op-error-modal";
  import ToolTipBox from "@/views/modules/ad/strategy/time-adjust/modal/tool-tip-box/tool-tip-box.vue"

  import AppAdPreviewModal from "@/views/modules/ad/common/modal/preview/ad-preview-modal"
  import {mapGetters} from "vuex";

  export default {
    name: "app-ad-time-adjust-strategy-op-modal",
    components: {AppAdjustPlacementBidStrategyForm, AppAdjustBudgetStrategyForm, AppAdjustBidStrategyForm},
    mixins: [modalMixIn, formRuleMixin, responseMixin],
    props: {
      opType: {
        type: Number,
        required: true
      },
      title: {
        type: String,
      },
      templateId: {
        type: Number
      },
      item: {
        required: false
      },
      objectId: {
        default: null
      },
      // 1：广告组、关键词、商品投放、投放组， 2：广告位， 3：广告活动
      strategyType: null
    },
    data() {
      return {
        temporaryTemplateId: -1,
        saveStrategyTpl: null,
        objectInfo: {},
        form: {
          name: null,
          proxyTemplateId: null,
          proxyTemplateName: '不使用模板',
          tplPlanState: true,
          date: null,
          share: false,
          notifyType:2,// 结果通知
          notifyUserList:[],//结果通知为 ：执行完成通知、有错误时通知 时，选中的人员
          bidForm: {
            items: []
          },
          budgetForm: {
            globalSet: false,
            adjustType: AdStrategyEnum.adjustForm.adjustType.PERCENT_ADD,
            adjustPercent: null,
            adjustValue: null,
            limit: null,
            items: [],
          },
          placementBidForm: {
            items: []
          }
        },
        adjustType: AdStrategyEnum.adjustType.bid,
        AdStrategyEnum: AdStrategyEnum,
        option: {
          templateLoading: false,
          template: [],
          // 结果通知 下拉框选项
          resultOption:AdStrategyEnum.resultOption
        },
        initForm$: null,
        loading: false,
        OpEnum: OpEnum,
        strategyGroup: [
          {id: 1, text: '调整竞价'},
          {id: 2, text: '调整广告位竞价'},
          {id: 3, text: '调整每日预算'}
        ],
        strategy: this.strategyType ? this.strategyType : 1,
        validatorName:(rule, value, callback)=>{
          if((this.form.notifyType === 0 || this.form.notifyType === 1) && this.form.notifyUserList.length === 0){
            return callback(new Error(`请选择通知人`))
          }else {
            callback()
          }
        },
        dayNames:[
          {id: 0, text: '周日'},
          {id: 1, text: '周一'},
          {id: 2, text: '周二'},
          {id: 3, text: '周三'},
          {id: 4, text: '周四'},
          {id: 5, text: '周五'},
          {id: 6, text: '周六'},
        ]
      }
    },
    created() {
      // 通知结果默认选中当前登录人
      this.form.notifyUserList.push(this.userInfo.userId);
      if (this.opType === OpEnum.type.USE) {
        this.loading = true;
        Promise.all(
                // 未添加分时策略，则objectId为空，使用默认模板
          [isMeaningful(this.objectId)
                  ? getAdsStrategyObjectInfoById(this.objectId)
                  : Promise.resolve(null),
            getAdsAdjustStrategyTplList()
          ])
          .then(([objectInfo, templates]) => {
            if (isMeaningful(objectInfo)) {
              this.objectInfo = objectInfo
              this.form.proxyTemplateId = objectInfo.templateId;
              this.form.tplPlanState = objectInfo.status === AdStrategyEnum.status.object.ENABLE;
              if (objectInfo.templateType === AdStrategyEnum.templateType.TEMPORARY) {
                // 对象已通过不使用模板添加模板，则更新不使用模板ID为对象的模板ID（默认的不使用模板ID为-1）
                this.temporaryTemplateId = objectInfo.templateId;
              }
            } else {
              this.form.proxyTemplateId = this.temporaryTemplateId;
            }
            this.option.template = [{
              id: this.temporaryTemplateId,
              text: '不使用模板',
            }].concat((templates || []).map(item => ({
              id: item.id,
              text: item.templateName
            })));
          })
          .complete(() => {
            this.loading = false;
            this.option.templateLoading = false;
          });
      } else if (this.opType === OpEnum.type.ADD) {
        this.initForm();
      } else if (this.opType === OpEnum.type.UPDATE) {
        this.form.proxyTemplateId = this.templateId;
      }
    },
    watch: {
      'form.proxyTemplateId': {
        handler: function (templateId) {
          if (isMeaningful(templateId)) {
            if (templateId !== -1) {
              this.initForm$ = null;
              this.initForm();
              this.loading = true;
              getAdsAdjustStrategyTplById(templateId)
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    const data = res.data;
                    // 基础信息
                    Object.assign(this.form, {
                      notifyType: data.notifyType||0,
                      notifyUserList: data.notifyUserList?.map(r => r.id)||[this.userInfo.userId],
                      name: data.templateName,
                      share: data.templateType === AdStrategyEnum.templateType.PUBLIC,
                      date: isMeaningful(data.startDate) ? [data.startDate, data.endDate] : null,
                    });
                    // 调整竞价
                    if (data.templateExpressionValue
                      && data.templateExpressionValue.bidDailies
                      && data.templateExpressionValue.bidDailies.expression
                      && data.templateExpressionValue.bidDailies.expression.length > 0) {
                      const bidDailies = data.templateExpressionValue.bidDailies.expression;
                      this.form.bidForm.items = bidDailies.map(item => ({
                        triggerType: item.triggerType,
                        repeat: item.dateList,
                        repeatOption: AdStrategyEnum.repeatOption.map(item => ({
                          ...item
                        })),
                        startTime: `${item.startHour>=10?item.startHour:'0'+item.startHour}:00`,
                        endTime: `${item.endHour>=10?item.endHour:'0'+item.endHour}:00`,
                        adjustType: item.budgetType,
                        adjustPercent: item.value,
                        adjustValue: item.value,
                        limit: item.max,
                      }));
                    }
                    // 调整每日预算
                    if (data.templateExpressionValue
                      && data.templateExpressionValue.budgetDailies
                      && data.templateExpressionValue.budgetDailies.expression
                      && data.templateExpressionValue.budgetDailies.expression.length > 0) {
                      const budgetDailies = data.templateExpressionValue.budgetDailies.expression;
                      this.form.budgetForm.items = budgetDailies.map(item => ({
                        triggerType: item.triggerType,
                        repeat: item.dateList,
                        repeatOption: AdStrategyEnum.repeatOption.map(item => ({
                          ...item
                        })),
                        startTime: `${item.startHour>=10?item.startHour:'0'+item.startHour}:00`,
                        endTime: `${item.endHour>=10?item.endHour:'0'+item.endHour}:00`,
                        adjustType: item.budgetType,
                        adjustPercent: item.value,
                        adjustValue: item.value,
                        limit: item.max,
                      }));
                    }
                    // 超出预算时策略(广告预算)
                    if (data.templateExpressionValue
                      && data.templateExpressionValue.dailyBudget
                      && data.templateExpressionValue.dailyBudget.expression) {
                      const dailyBudget = data.templateExpressionValue.dailyBudget;
                      const dailyBudgetExpression = data.templateExpressionValue.dailyBudget.expression;
                      Object.assign(this.form.budgetForm, {
                        globalSet: dailyBudget.allowUsed,
                        adjustType: dailyBudgetExpression.budgetType,
                        adjustPercent: dailyBudgetExpression.value,
                        adjustValue: dailyBudgetExpression.value,
                        limit: dailyBudgetExpression.max
                      });
                    }
                    // 调整广告位竞价
                    if (data.templateExpressionValue
                      && data.templateExpressionValue.placementDailies
                      && data.templateExpressionValue.placementDailies.expression
                      && data.templateExpressionValue.placementDailies.expression.length > 0) {
                      const placementDailies = data.templateExpressionValue.placementDailies.expression;
                      this.form.placementBidForm.items = placementDailies.map(item => ({
                        triggerType: item.triggerType,
                        repeat: item.dateList,
                        repeatOption: AdStrategyEnum.repeatOption.map(item => ({
                          ...item
                        })),
                        startTime: `${item.startHour>=10?item.startHour:'0'+item.startHour}:00`,
                        endTime: `${item.endHour>=10?item.endHour:'0'+item.endHour}:00`,
                        adjustType: item.budgetType,
                        adjustPercent: item.value,
                        adjustValue: item.value,
                        limit: item.max,
                      }));
                    }
                  });
                })
                .complete(() => this.loading = false);
            }else {
              this.initForm();
            }
          }
        },
        immediate: true
      }
    },
    computed: {
      ...mapGetters(['userInfo', 'userOptions']),
      // 判断是否从选中到取消
      tplPlanStateChange() {
        if (this.objectInfo.status == AdStrategyEnum.status.object.ENABLE && !this.form.tplPlanState) {
          return true
        }else {
          return false
        }
      },
      showLogBtn() {
        return this.opType === OpEnum.type.USE && isMeaningful(this.form.proxyTemplateId) && this.form.proxyTemplateId !== -1;
      },
      hasBidDailies() {
        if (this.$refs.bidStrategyForm) {
          return !this.$refs.bidStrategyForm.initState;
        }
        return true;
      },
      hasDailyBudget() {
        if (this.$refs.budgetStrategyForm) {
          return !this.$refs.budgetStrategyForm.dailyBudgetInitState;
        }
        return true;
      },
      hasBudgetDailies() {
        if (this.$refs.budgetStrategyForm) {
          return !this.$refs.budgetStrategyForm.budgetDailiesInitState;
        }
        return true;
      },
      hasPlacementDailies() {
        if (this.$refs.placementBidForm) {
          return !this.$refs.placementBidForm.initState;
        }
        return true;
      },
      params() {
        const params = {
          // adsType: AdTypeEnum.SP,
          templateName: this.form.name,//模板名
          templateType: this.form.share ? AdStrategyEnum.templateType.PUBLIC : AdStrategyEnum.templateType.PRIVATE,// 模板类型
          startDate: isMeaningful(this.form.date) ? convertToDate(this.form.date[0]) : null,// 开始时间
          endDate: isMeaningful(this.form.date) ? convertToDate(this.form.date[1]) : null,// 结束时间
          templateExpressionValue: {},
          notifyType: this.form.notifyType,// 通知类型 ------ **枚举值**: `0`: 不通知 `1`: 执行完成通知 `2`: 有错误时通知
          // 通知用户集合
          notifyUserList: this.form.notifyUserList.map(r => {
            return {id: r, name: this.userOptions.find(n => n.id === r).text}
          })
        };
        if (this.opType === OpEnum.type.UPDATE) {
          params.id = this.templateId;
        }
        // 调整竞价
        if (this.hasBidDailies) {
          params.templateExpressionValue.bidDailies = {
            allowUsed: true,
            expression: this.form.bidForm.items.map(item => ({
              triggerType: item.triggerType,
              dateList: item.repeat,
              startHour: Number(item.startTime.split(":")[0]),
              endHour: Number(item.endTime.split(":")[0]),
              budgetType: item.adjustType,
              value:  item.adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_ADD
              || item.adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_SUB
                  ? item.adjustPercent : item.adjustValue,
              max: item.adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_ADD
              || item.adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_SUB
                  ? item.limit : null
            }))
          }
        }
        // 调整每日预算
        if (this.hasBudgetDailies) {
          params.templateExpressionValue.budgetDailies = {
            allowUsed: true,
            expression: this.form.budgetForm.items.map(item => ({
              triggerType: item.triggerType,
              dateList: item.repeat,
              startHour: Number(item.startTime.split(":")[0]),
              endHour: Number(item.endTime.split(":")[0]),
              budgetType: item.adjustType,
              value:  item.adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_ADD
              || item.adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_SUB
                  ? item.adjustPercent : item.adjustValue,
              max: item.adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_ADD
              || item.adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_SUB
                  ? item.limit : null
            }))
          }

          if (params.templateExpressionValue && params.templateExpressionValue.dailyBudget) {
            params.templateExpressionValue.dailyBudget.allowUsed = false
          }

        }
        // 	超出预算时策略(广告预算)
        if (this.hasDailyBudget) {
          params.templateExpressionValue.dailyBudget = {
            allowUsed: this.form.budgetForm.globalSet,
            expression: {
              budgetType: this.form.budgetForm.adjustType,
              value: this.form.budgetForm.adjustType === AdStrategyEnum.budgetForm.adjustType.PERCENT_ADD
                ? this.form.budgetForm.adjustPercent : this.form.budgetForm.adjustValue,
              max: this.form.budgetForm.adjustType === AdStrategyEnum.budgetForm.adjustType.PERCENT_ADD
                ? this.form.budgetForm.limit : null
            }
          }
          if (params.templateExpressionValue && params.templateExpressionValue.budgetDailies) {
            params.templateExpressionValue.budgetDailies.allowUsed = false
          }
        }
        // 调整广告位
        if (this.hasPlacementDailies) {
          params.templateExpressionValue.placementDailies = {
            allowUsed: true,
            expression: this.form.placementBidForm.items.map(item => ({
              triggerType: item.triggerType,
              dateList: item.repeat,
              startHour: Number(item.startTime.split(":")[0]),
              endHour: Number(item.endTime.split(":")[0]),
              budgetType: item.adjustType,
              value:  item.adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_ADD
              || item.adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_SUB
                ? item.adjustPercent : item.adjustValue,
              max: item.adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_ADD
              || item.adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_SUB
                ? item.limit : null
            }))
          }
        }
        return params;
      }
    },
    methods: {
      initForm() {
        this.initForm$ = {};
      },
      proxyTemplateInput(option) {
        this.form.proxyTemplateName = option.text;
      },
      viewLog() {
        // this.$gjCreate(AppStrategyTplLogModal, {
        //   props: {
        //     tplId: this.form.proxyTemplateId,
        //     tplName: this.form.proxyTemplateName
        //   }
        // });
        this.$emit('viewLog', this.item);
      },
      formValidate() {
        if (!this.$gjFormValidate()) {
          return false;
        }
        if (!this.hasBidDailies && !this.hasDailyBudget && !this.hasBudgetDailies && !this.hasPlacementDailies) {
          this.$gjMessage.error('调整竞价、调整每日预算、调整广告位竞价，请至少填一项');
          return false;
        }
        if (this.$refs.bidStrategyForm && !this.$refs.bidStrategyForm.formValidate()) {
          this.$gjMessage.error('调整竞价信息有错误，请更正后再提交');
          return false;
        }
        if (this.$refs.budgetStrategyForm && !this.$refs.budgetStrategyForm.formValidate()) {
          this.$gjMessage.error('调整每日预算信息有错误，请更正后再提交');
          return false;
        }
        if (this.$refs.placementBidForm && !this.$refs.placementBidForm.formValidate()) {
          this.$gjMessage.error('调整广告位竞价信息有错误，请更正后再提交');
          return false;
        }
        return true;
      },
      //保存为模板
      saveTpl() {
        if (this.formValidate()) {
          this.saveStrategyTpl = this.$gjCreate(AppSaveStrategyTplModal, {
            on: {
              save: (form) => {
                this.saveStrategyTpl.confirmLoading = true;
                const params = {
                  templateName: form.name,
                  templateType: form.share ? AdStrategyEnum.templateType.PUBLIC : AdStrategyEnum.templateType.PRIVATE,
                };
                this.useHandle(params, () => {
                  this.saveStrategyTpl.$gjDestroy();
                });
              }
            }
          });
        }
      },
      // 提交前的判断
      isPopupFn() {
        return new Promise( async (resolve, reject) => {
          let data = []
          //若是从商品广告各个tab点开窗口
          if (this.opType === this.OpEnum.type.USE) {
            //未添加分时策略(创建策略)
            if (this.item.strategyStatus == 2) {
              resolve({resume: false})
            }
            //已开启或已关闭分时状态(修改策略)
            else {
              let params = [{
                status: this.form.tplPlanState ? AdStrategyEnum.status.object.ENABLE : AdStrategyEnum.status.object.PAUSE,
                operatingType: 1,// 操作类型（0:修改模板，1：修改策略）
                objectPid: this.objectId,
                templateExpressionValue: this.params.templateExpressionValue
              }]
              try {
                data = await getResumeCondition(params)
              } catch (error) {
                this.confirmLoading = false
                return false
              }
            }
          }
          // 若是 从分时策略模板页 点击编辑打开窗口
          else {
            let params = [{
              operatingType: 0,// 操作类型（0:修改模板，1：修改策略）
              templatePid: this.templateId,
              templateExpressionValue: this.params.templateExpressionValue
            }]
            try {
              data = await getResumeCondition(params)
            } catch (error) {
              return false
            }
          }
          if (data && data.length > 0) {
            let msg = this.tplPlanStateChange 
              ? '分时调价策略正在生效中，请确认是否需要将预算和竞价恢复到基础预算和竞价' 
              : '调整后的新策略将在下一个生效时段开始生效，请确认是否需要将当前正在生效的分时预算和竞价恢复到基础预算和竞价？'
            this.$gjCreate(ToolTipBox, {
              props: {
                msg,
                data: data
              },
              on: {
                update: (type, resumeTaskId) => {
                  resolve({resume: type, resumeTaskId})
                },
                close: () => {
                  this.confirmLoading = false;
                  this.saveStrategyTpl && (this.saveStrategyTpl.confirmLoading = false);
                }
              }
            });
          }else {
            resolve({resume: false})
          }
        })
      },
      //预览
      preview() {
        if (this.formValidate()) {

          //获取当前需要预览的数据
          let bidForm = this.getPreviewData(this.form.bidForm.items);
          let placementBidForm = this.getPreviewData(this.form.placementBidForm.items);
          let budgetForm = this.getPreviewData(this.form.budgetForm.items);


          //若有冲突时段，弹出提示并return
          if (bidForm.errorData.length > 0) {
            this.errorTip({bidDailies: bidForm.errorData})
            return
          }else if (placementBidForm.errorData.length > 0) {
            this.errorTip({bidDailies: placementBidForm.errorData})
            return
          }else if (budgetForm.errorData.length > 0) {
            this.errorTip({bidDailies: budgetForm.errorData})
            return
          }
          // 生成预览弹窗
          let param ={
            strategy: this.strategy,//默认选中的tab
            strategyType: this.strategyType,//用于区分从哪个父级模块大概此modal
            defaultNum: null, //默认基础值
            form: {
              bidForm:bidForm.items,
              placementBidForm:placementBidForm.items,
              budgetForm:budgetForm.items,
            }
          }
          //广告活动  默认基础值 === 原始预算
          if(this.strategyType === 3){
            param.defaultNum = this.item.originalBudget
          }
          //广告组、关键词、商品投放、投放组  默认基础值 === 原始竞价
          else if(this.strategyType === 1){
            param.defaultNum = this.item.originalBid
          }
          this.$gjCreate(AppAdPreviewModal, {
            props: param,
          });
        }
      },
      //处理预览数据
      getPreviewData(data){
        //按天初始化整个星期的每个小时
        let dayTimeData = [];
        for (let i = 0; i < 7; i++) {
          dayTimeData.push({
            '00:00': 0,
            '01:00': 0,
            '02:00': 0,
            '03:00': 0,
            '04:00': 0,
            '05:00': 0,
            '06:00': 0,
            '07:00': 0,
            '08:00': 0,
            '09:00': 0,
            '10:00': 0,
            '11:00': 0,
            '12:00': 0,
            '13:00': 0,
            '14:00': 0,
            '15:00': 0,
            '16:00': 0,
            '17:00': 0,
            '18:00': 0,
            '19:00': 0,
            '20:00': 0,
            '21:00': 0,
            '22:00': 0,
            '23:00': 0,
            '24:00': 0
          })
        }
        //根据需要预览的数据，生成预览展示的数据
        let items = [];
        data.forEach(i => {
          //周日-周六：0-6
          i.repeat.forEach(r => {
            //若选中的是每天 则生成7条数据
            if (r === 0) {
              for (let m = 0; m < 7; m++) {
                items.push({
                  day: m,
                  dayName: this.dayNames.find(n => n.id === m).text,
                  adjustPercent: i.adjustPercent,
                  adjustType: i.adjustType,
                  adjustValue: i.adjustValue,
                  limit: i.limit,
                  startTime: i.startTime,
                  endTime: i.endTime,
                  triggerType: i.triggerType,
                })
              }
            }
            //若选中的是周日 则day 为0
            else if (r === 7) {
              items.push({
                day: 0,
                dayName: '周日',
                ...i
              })
            }
            //否则
            else {
              items.push({
                day: r,
                dayName: this.dayNames.find(n => n.id === r).text,
                ...i
              })
            }
          })
        })

        //遍历用于展示的数据
        let errorData = [];
        for(let item of items){
          let start = false;
          //按天遍历dayTimeData
          for(let i in dayTimeData[item.day]){
            if(item.startTime === i){
              start = true
            }
            if(item.endTime === i){
              start = false
            }
            if(start){
              //若有冲突时段，记录弹窗提示信息
              if (dayTimeData[item.day][i] === 1) {
                errorData.push({error: '时间段有交叉，请重新设置', weekStr: item.dayName})
              }
              // 否则
              else {
                dayTimeData[item.day][i] += 1;
              }
            }
          }
        }
        return {
          items: this._.sortBy(items,'day','startTime'),
          errorData
        }
      },
      // 确定
      async confirm() {
        if (this.formValidate()) {
          this.confirmLoading = true;
          // 分时策略-添加模板
          if (this.opType === OpEnum.type.ADD) {
            await addAdsAdjustStrategyTpl(this.params)
                .then((res) => {
                  this.$gjResponseHandle(res,
                      () => {
                        this.$gjMessage.success('创建成功');
                        this.$emit('created');
                        this.$gjDestroy();
                      },
                      () => this.errorTip(res.data));
                })
                .complete(() => this.confirmLoading = false);
          }
          // 分时策略-编辑
          else if (this.opType === OpEnum.type.UPDATE) {
            let data = await this.isPopupFn() // 校验
            if (data.resume === -1) {
              return false
            }
            await updateAdsAdjustStrategyTpl({
              ...this.params,
              resume:data.resume,
              resumeTaskId: data.resumeTaskId
            }).then((res) => {
                this.$gjResponseHandle(res,
                    () => {
                      this.$gjMessage.success('更新成功');
                      this.$emit('updated');
                      this.$gjDestroy();
                    },
                    () => this.errorTip(res.data));
              })
              .complete(() => this.confirmLoading = false);
          }
          // 广告活动、广告组-分时策略（使用模板）
          else if (this.opType === OpEnum.type.USE) {
            await this.useHandle();
          }
        }
      },
      async useHandle(tplParams = {}, callbackMap) {
        let data = await this.isPopupFn() // 校验
        if (data.resume === -1) {
          return false
        }
        let callback = (res) => {
          this.$gjResponseHandle(res,
            () => {
              this.$emit('updated');
              callbackMap && callbackMap()
            },
            () => {
              this.errorTip(res.data)
              callbackMap && callbackMap()
            })
        }
        const params = this.params;
        if (this.form.proxyTemplateId !== -1) {
          params.id = this.form.proxyTemplateId;
        } else {
          params.templateName = null;
        }
        params.templateType = null;
        this.$emit('useStrategy', {
          params: {
            ...params,
            ...tplParams,
            resume:data.resume,
            resumeTaskId: data.resumeTaskId
          },
          templateId: this.form.proxyTemplateId,
          status: this.form.tplPlanState
            ? AdStrategyEnum.status.object.ENABLE
            : AdStrategyEnum.status.object.PAUSE,
          callback: callback,
          resumeDTO: data
        });
      },
      errorTip(data) {
        this.$gjCreate(AppTimeAdjustStrategyOpErrorModal, {
          props: {
            data,
          }
        });
      }
    }
  }
</script>

<style scoped lang="scss">

  /deep/ .el-dialog__body  {
    .vxe-table--border-line{
      border: 1px solid #e8eaec !important;
    }
  }
  /deep/.el-checkbox__label {
    height: 32px;
    line-height: 32px !important;
  }
  /deep/.el-input__suffix {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /deep/.chunk-input-item{
    .el-input__suffix-inner {
      margin-top: 0px !important;
    }
  }
  /deep/.el-form-item__label {
    height: 32px;
    line-height: 32px !important;
  }
  .adjust-type-body {
    margin-top: 15px;
  }
  /deep/ .el-tabs__header {
    margin-bottom: 10px;
  }
  /deep/ .el-tabs__item {
    height: 36px;
    line-height: 36px;
    font-size: 12px;
    padding: 0 12px !important;
  }
  /deep/ .el-tabs__content {
    padding: 0 !important;
  }
  /deep/ .el-tabs__nav {
    margin-left: 0 !important;
  }
  .log-btn {
    position: absolute;
    right: 10px;
    z-index: 99;
    top: 4px;
  }
  /deep/ .gj-help--icon{
    color: #999999;
  }
  .tooltip-dot{
    flex: none;
    width: 8px;
    height: 8px;
    background-color: white;
    border-radius: 50%;
    display: inline-block;
    margin: 0 6px 0 2px;
  }
  /deep/ .el-select__tags{
    z-index: 2;
  }
  /deep/ .el-input{
    z-index: 1;
  }
</style>

